import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from '../../actions/get-quotes';
import Constants from '../../constants/Articles';
import HeroJumbotron from './HeroJumbotron';
import HeroJumbotronTradie from './HeroJumbotronTradie';

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export class HeroJumbotronContainer extends Component<any, any> {
  static propTypes = {
    category: PropTypes.object,
    categoryPerson: PropTypes.string,
    categoryPersonPlural: PropTypes.string,
    actions: PropTypes.object,
    heroImage: PropTypes.string,
    heroType: PropTypes.string,
    isModal: PropTypes.bool,
    setModalData: PropTypes.func
  };

  render() {
    const { submitSelection } = this.props.actions;
    const {
      category,
      categoryPerson,
      categoryPersonPlural,
      heroImage,
      heroType,
      isModal,
      setModalData
    } = this.props;
    return (
      <div>
        {heroType === 'tradie_signup' ? (
          <HeroJumbotronTradie heroImage={heroImage} />
        ) : (
          <HeroJumbotron
            category={category}
            categoryPerson={categoryPerson || Constants.CATEGORY_PERSON_DEFAULT}
            categoryPersonPlural={categoryPersonPlural || Constants.CATEGORY_PERSON_PLURAL_DEFAULT}
            submitSelection={submitSelection}
            heroImage={heroImage}
            isModal={isModal}
            setModalData={setModalData}
          />
        )}
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HeroJumbotronContainer);
